<template>
  <section>
    <v-dialog
      v-model="value"
      width="400px"
    >
      <div class="dialog-container">
        <div class="dialog-header">
          <span>{{step==1?'Handling':'System Message'}}</span>
        </div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="dialog-body">
            <div
              v-show="step==1"
              class="form-item box pd-b-30">
              <el-form-item
                ref="cs_team_id"
                :rules="rules.select"
                prop="cs_team_id">

                <section class="select-type">
                  <label
                    v-for="(item,index) in agencyList"
                    :key="index"
                    class="select-pay"
                    :class="{'checked':formData.agency_id==item.id}">
                    <el-radio
                      v-model="formData.cs_team_id"
                      :label="item.id"
                      @change="handleChange"
                    >
                      <div class="flex-align-center">
                        <span>
                          <span class="header-box">
                            <img
                              v-if="item.agency_icon"
                              :src="item.agency_icon">
                          </span>
                        </span>
                        <span class="select-span">{{item.name}}</span>
                      </div>
                    </el-radio
                    >
                  </label>
                </section>
              </el-form-item>
            </div>
            <div v-if="step==2">
              <div class="form-item type-button pd-b-30">
                <el-form-item
                  ref="enquiry_type"
                  :rules="rules.select"
                  prop="lang">
                  <v-radio-group
                    v-model="formData.lang"
                    :list="lanuageList"
                    @change="handleChange"/>
                </el-form-item>
              </div>
              <div class="form-item mg-b-15">
                <v-checkbox
                  v-model="formData.email_content_1.is_send"
                  :is-boolean="false"
                  class="mg-b-8">{{isHoldCover?(isFina?'Fina':'HoldCover'):agencyOriginalName}}</v-checkbox>
                <el-form-item
                  ref="email_content_1.message"
                  :rules="rules.input"
                  prop="email_content_1.message">
                  <v-input
                    v-model="formData.email_content_1.message"
                    type="textarea"
                    :rows="4"></v-input>
                </el-form-item>
              </div>
              <div class="form-item mg-b-15">
                <v-checkbox
                  v-model="formData.email_content_2.is_send"
                  :is-boolean="false"
                  class="mg-b-8">{{isHoldCover||isAgency?agencyName:(isFina?'Fina':'HoldCover')}}</v-checkbox>
                <el-form-item
                  ref="email_content_2.message"
                  :rules="rules.input"
                  prop="email_content_2.message">
                  <v-input
                    v-model="formData.email_content_2.message"
                    type="textarea"
                    :rows="4"></v-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
        <template>
          <div
            class="dialog-footer">
            <v-button
              gray
              @click="handleCancel">{{cancelText}}</v-button>
            <div>
              <v-button
                green
                @click="handleNext">
                {{step==1?'Confirm':'Send'}}
              </v-button>
            </div>
          </div>
        </template>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import dayjs from 'dayjs'
import {mapActions, mapState} from 'vuex'
import {setEnquiryAgency } from '@/api/enquiry'
export default {
  name: 'enquiryHandlingDialog',
  components:{
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    value:{
      type:Boolean,
      default:false
    },
    cancelText:{
      type:String,
      default:'Cancel'
    },
    btnText:{
      type:String,
      default:'Confirm'
    },
    agencyId:{
      type:Number,
      default:0
    },
    detail:{
      type:Object,
      default:()=>({})
    },
  },
  data(){
    return{
      isShow:false,
      selectType:-1,
      step:1,
      formData:{
        cs_team_id:0,
        lang:'zh-HK',
        message:'',
        email_content_1:{
          agency_id:'',
          message:'',
          is_send:1
        },
        email_content_2:{
          agency_id:'',
          message:'',
          is_send:1
        }
      },
    }
  },
  computed: {
    isSame(){
      let {cs_team_id} = this.formData
      return Number(cs_team_id) ==Number(this.agencyId)
    },
    isFina(){
      let {merchant_platform} = this.formData
      return merchant_platform == 2
    },
    agencyList(){
      let {cs_team} = this.globalOptions||{}
      return cs_team
    },
    agencyName(){
      let {cs_team_id} = this.formData
      let obj = this.agencyList.find(item=>item.id==cs_team_id)||{}
      return obj.full_name
    },
    agencyOriginalName(){
      let obj = this.agencyList.find(item=>item.id==this.agencyId)||{}
      return obj.full_name
    },
    enquiry_id(){
      let {id} = this.$route.query
      return id
    },
    lanuageList(){
      return [
        {
          id:'zh-HK',
          name:'中文'
        },
        {
          id:'en-US',
          name:'English'
        }
      ]
    },
    isAgency(){
      let {cs_team_id,holdcover_cs_team_id,fina_cs_team_id} = this.detail
      if(this.isFina)
        return (fina_cs_team_id!=cs_team_id||cs_team_id!=0)&&this.formData.cs_team_id!=8
      return (holdcover_cs_team_id!=cs_team_id||cs_team_id!=0)&&this.formData.cs_team_id!=7
    },
    isHoldCover(){
      let {cs_team_id,holdcover_cs_team_id,fina_cs_team_id} = this.detail
      if(this.isFina)
        return cs_team_id==0||fina_cs_team_id==cs_team_id
      return cs_team_id==0||holdcover_cs_team_id==cs_team_id
    },
    holdCover_content(){
      let {email_content={}} = this.detail||{}
      let content = email_content[this.isHoldCover||this.isAgency?1:2]||{}
      let {holdcover}  =content||{}
      let {lang} = this.formData
      let holdCover_content = holdcover[lang]
      holdCover_content =  holdCover_content.replaceAll('{agency_name}',this.agencyName)
      return holdCover_content
    },
    agency_content(){
      let {email_content={}} = this.detail||{}
      let content = email_content[this.isHoldCover||this.isAgency?1:2]
      let {agency}  =content||{}
      let {lang} = this.formData
      let agency_content = agency[lang]
      return agency_content
    }
  },
  watch:{
    agencyId:{
      immediate:true,
      handler(val){
        if(val){
          this.formData.cs_team_id =val
        }
      }
    }
  },
  destroyed() {
  },
  methods:{
    handleChange(){
      this.formData.email_content_1.message=this.isHoldCover||this.isAgency?this.holdCover_content:this.agency_content
      this.formData.email_content_2.message =this.isHoldCover||this.isAgency?this.agency_content:this.holdCover_content
    },
    handleCancel(){
      this.$refs['form'].resetFields()
      if(this.step==2){
        this.step = 1
      }else
        this.$emit('input',false)
    },
    handleNext(){
      this.$refs.form.validate( (valid) => {
        if (valid) {
          if(this.isSame){
            this.$emit('input',false)
            return
          }
          if(this.step==1){
            this.formData.email_content_1 ={
              cs_team_id : this.agencyId,
              message :  this.isHoldCover||this.isAgency?this.holdCover_content:this.agency_content,
              is_send:1
            }
            this.formData.email_content_2 ={
              cs_team_id : this.formData.cs_team_id,
              message : this.isHoldCover||this.isAgency?this.agency_content:this.holdCover_content,
              is_send:1
            }
            this.step = 2
          }else
            this.network().setEnquiryAgency()
        }

      })

    },
    network() {
      return {
        setEnquiryAgency: async (params={}) => {
          let params_form = JSON.parse(JSON.stringify(this.formData))
          let {email_content_1,email_content_2} = this.formData
          params.email_content = [
            email_content_1,
            email_content_2
          ]
          delete params_form.email_content_1
          delete params_form.email_content_2
          const {data} = await setEnquiryAgency({
            enquiry_id:this.enquiry_id,
            ...params_form,
            ...params
          })
          this.step = 1

          this.$emit('update:agency',this.formData.cs_team_id)
          this.$emit('input',false)
          this.$emit('refresh')

        },
      }
    }
  },

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
  font-family: 'inter';
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      /*margin: 10px 0px;*/
    }
  }
  .dialog-body{
    padding: 20px 15px;
    max-height: 468px;
    overflow-y: auto;
    .header-box{
      height: 50px;
      width: 50px;
      border-radius: 25px;
      border: 1px solid #E6EAEF;
      display: block;
      margin-right: 16px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 50px;
      }
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;

  }
  .box{

  }
  .form-item{
    .select-type{
      display: flex;
      flex-direction: column;
    }
  }
  .type-button {
    /deep/ .el-radio-group{
      display: flex;
    }
    ::v-deep .el-radio {
      //margin-right: 23px;
      margin-top: 8px;
      width: 50%;
      .el-radio__label {
        display: inline-block;

        padding: 0px 10px;
        height: auto;
        //line-height: 30px;
        font-size: 12px;
        border-radius: 50px;
        border: 1px solid #E1E4E8;
        color: #24292E;
        background: white;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 18px;
        margin-left:8px ;
        margin-right: 23px;
      }
    }
  }
  .select-pay {
    border: 1px solid #d1d5da;
    border-radius: 5px;
    background-color: #ffffff;
    padding: 20px;
    margin-bottom: 16px;
    width:100%;
    display: block;
    .el-radio{
      display: flex;
      align-items: center;
    }
    &.checked{
      border-color: #409EFF;
    }
    .select-span {
      color: #24292e;
      font-family: Inter;
      font-size: 14px;
      white-space: normal;
    }
    .icon-block{
      display: block;
      width: 42px;
      height: 42px;
      margin: 0 20px;
      img{
        width: 42px;
      }
    }
    .margin-top {
      margin-top: 20px;
    }
  }
}
</style>
